import { API_BASE_PATH } from 'constants/new-configs';
import http from './http';
import type { FMOptions } from './model/fetcher-mutation';

/**
 * @function fetcherMutation
 * @param options
 */
const fetcherMutation = async (options: FMOptions) => {
  const { variables, context } = options;
  const { path = '', method, headers = {}, meta = {}, isFormData } = context;

  const token = meta.token as string | undefined;
  const basePath = meta.basePath as string | undefined;
  const baseURL = meta.baseUrl as string | undefined;
  const keepalive = meta.keepalive as boolean | undefined;

  if (!isFormData) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await http({
    path: `${basePath || API_BASE_PATH}/${path}`,
    body: variables,
    method: method ?? 'POST',
    headers,
    token,
    baseURL,
    keepalive,
  });

  return Promise.resolve(response);
};

export default fetcherMutation;
